import type { Phase, RuntimeEvent } from "./events";

export function nextPhaseFromEvent(current: Phase, event: RuntimeEvent): Phase {
  switch (event.type) {
    case "runtime.ready":
      return current === "booting" ? "provisioning" : current;
    case "vad.start":
      return current === "speaking" ? "interrupted" : "speech_detected";
    case "vad.end":
      return "transcribing";
    case "stt.partial":
      return current === "speech_detected" ? "transcribing" : current;
    case "stt.final":
      return "thinking";
    case "llm.delta":
      return "thinking";
    case "llm.done":
      return "speaking";
    case "tts.audio":
      return "speaking";
    case "tts.done":
      return "idle";
    case "error":
      return "error";
    default:
      return current;
  }
}
